/******** Get User from store  ***********/
export const User = (store) => {
  return store.getState().user;
};

/******** Routing authentication middleware ***********/
export const Auth = (store) => {
  return User(store).loggedIn;
};

/******** Set Authorization token in header ***********/
export const setAuthorizationToken = (axios: any, token: any) => {
  if (token) {
    axios.defaults.headers.common.Authorization = token;
  } else {
    delete axios.defaults.headers.common.Authorization;
  }
};

/******** Set Access token from session ***********/
export const setAccessToken = (token: any) => {
  if (token) {
    localStorage.setItem("token", token);
  } else {
    localStorage.removeItem("token");
  }
};

/******** Remove Access token from session ***********/
export const removeToken = () => {
  localStorage.removeItem("token");
  window.location.href = "/";
};

/******** Get Access token from session ***********/
export const getAccessToken = () => {
  const localToken = localStorage.getItem("token");
  return localToken;
};
